/**
 * 缓存说明:事件缓存
 */
import vm from '@/cache/storeTools.js'
import workorderApi from '@/components/api/projectDingZhi/ningbo/workorderApi.js'

var basestate = {
    inited: false,
    berthList: [],
    areaList: [],
    typeList: [],
    dockDevList: [],
    workorder: null,
}

var store = new vm.Vuex.Store({
    state: copy(basestate),
    getters: {
        getBerthList(state, getters) {
            return state.berthList
        },
        getAreaList(state, getters) {
            return state.areaList
        },
        getTypeList(state, getters) {
            return state.typeList
        },
        getDockDevList(state, getters) {
            return state.dockDevList
        },
        getWorkorder(state, getters) {
            return state.workorder;
        }
    },
    mutations: {
        init(state) {
            if (state.inited) {
                return;
            }
            workorderApi.findAllDicBerth(respon => {
                vm.Vue.set(state, 'berthList', respon)
            })
            workorderApi.findAllDicArea(respon => {
                vm.Vue.set(state, 'areaList', respon)
            })
            workorderApi.findAllDicType(respon => {
                vm.Vue.set(state, 'typeList', respon)
            })
            workorderApi.findAllDicDockDev(respon => {
                vm.Vue.set(state, 'dockDevList', respon)
            })
        },
        appendBerth(state, berth) {
            this.berthList.push(berth)
        },
        setBerthList(state, berthList) {
            console.log("ningboStore.setBerthList");
            state.berthList = berthList;
        },
        setWorkorder(state, workorder) {
            state.workorder = workorder;
        }
    }
});
//对外提供
export default store